import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import {
    fetchBiometricDeviceUsersPage,
    selectBiometricUsers,
} from '../features/biometric-user/biometric-user.slice';
import { getDefaultBiometricDeviceUserSearchCriteria } from '../service/model/biometric.model';

const useBiometricUsers = (deviceId?: number) => {
    const dispatch = useAppDispatch();
    const biometricUsers = useAppSelector(selectBiometricUsers);

    const getBiometricUsers = async () => {
        await dispatch(
            fetchBiometricDeviceUsersPage(getDefaultBiometricDeviceUserSearchCriteria(deviceId)),
        );
    };

    useEffect(() => {
        if (deviceId && biometricUsers.length === 0) {
            getBiometricUsers();
        }
    }, [biometricUsers.length, deviceId]);

    return [biometricUsers, getBiometricUsers] as const;
};

export default useBiometricUsers;
